import { createId } from "../../app/runtimeContext";
import type { CyanIntelligenceRepository } from "./repositories";
import type {
  ApprovalEvent,
  ApprovalRequest,
  ApprovalStatus,
} from "./liveTypes";

export class ApprovalEngine {
  constructor(private readonly repository: CyanIntelligenceRepository) {}

  async request(
    input: Omit<ApprovalRequest, "id" | "status" | "createdAt" | "updatedAt">,
  ): Promise<ApprovalRequest> {
    const now = new Date().toISOString();
    const approval: ApprovalRequest = {
      ...input,
      id: createId("approval"),
      status: "pending",
      createdAt: now,
      updatedAt: now,
    };
    await this.repository.saveApproval(approval);
    return approval;
  }

  async decide(
    approval: ApprovalRequest,
    action: ApprovalStatus,
    actor: string,
    reason: string,
  ): Promise<ApprovalRequest> {
    const updated = {
      ...approval,
      status: action,
      decidedBy: actor,
      decisionReason: reason,
      updatedAt: new Date().toISOString(),
    };
    const event: ApprovalEvent = {
      id: createId("approval_event"),
      approvalId: approval.id,
      action,
      actor,
      reason,
      createdAt: updated.updatedAt,
    };
    await this.repository.saveApproval(updated);
    await this.repository.saveApprovalEvent(event);
    return updated;
  }
}
